export const common = {
  // Navigation
  'nav.home': 'Accueil',
  'nav.services': 'Services',
  'nav.pricing': 'Tarifs',
  'nav.about': 'À propos',
  'nav.transfers': 'Nos Transferts',
  'nav.chambery': 'Aéroport Chambéry',
  'nav.lyon': 'Aéroport Lyon',
  'nav.blog': 'Blog',
  'nav.contact': 'Contact',
  'nav.book': 'Réserver',
  'nav.phone': '+33 6 05 60 60 06',

  // Hero Section
  'hero.title': 'Transferts Privés vers les Stations de Ski des Alpes',
  'hero.subtitle': 'Service premium depuis les aéroports de Genève, Lyon et Chambéry vers les plus belles stations de ski des Alpes',
  'hero.cta.book': 'Réserver Votre Transfert',
  'hero.cta.quote': 'Obtenir un Devis',

  // Services
  'services.title': 'Nos Services Premium',
  'services.subtitle': 'Confort et sécurité pour tous vos déplacements',
  'services.airport.title': 'Transferts Aéroport',
  'services.airport.desc': 'Service direct depuis les aéroports de Genève, Lyon et Chambéry',
  'services.private.title': 'Transferts Privés',
  'services.private.desc': 'Véhicules confortables pour 1 à 8 passagers',
  'services.24h.title': 'Disponible 24/7',
  'services.24h.desc': 'Service disponible jour et nuit, 7 jours sur 7',
  'services.tracking.title': 'Suivi des Vols',
  'services.tracking.desc': 'Nous surveillons votre vol pour ajuster l\'heure de prise en charge',

  // Destinations
  'destinations.title': 'Destinations Populaires',
  'destinations.subtitle': 'Les plus belles stations de ski des Alpes',
  'destinations.viewAll': 'Voir Toutes les Destinations',
  'destinations.privateTransfer': 'Transfert Privé',

  // Stats
  'stats.clients': 'Clients Satisfaits',
  'stats.transfers': 'Transferts Réalisés',
  'stats.destinations': 'Destinations',
  'stats.experience': 'Ans d\'Expérience',

  // Testimonials
  'testimonials.title': 'Ce Que Disent Nos Clients',
  'testimonials.subtitle': 'Des milliers de voyageurs satisfaits',

  // FAQ
  'faq.title': 'Questions Fréquentes',
  'faq.subtitle': 'Tout ce que vous devez savoir sur nos services',

  // CTA
  'cta.title': 'Prêt à Réserver Votre Transfert ?',
  'cta.subtitle': 'Obtenez un devis instantané et réservez en quelques clics',
  'cta.button': 'Obtenir un Devis Gratuit',

  // Footer
  'footer.description': 'Service de transfert privé premium vers les stations de ski des Alpes. Confort, sécurité et ponctualité garantis.',
  'footer.services': 'Services',
  'footer.destinations': 'Destinations',
  'footer.company': 'Entreprise',
  'footer.contact': 'Contact',
  'footer.legal': 'Mentions Légales',
  'footer.rights': 'Tous droits réservés',
  'footer.poweredBy': 'Création de Site',

  // Contact
  'contact.title': 'Contactez-Nous',
  'contact.subtitle': 'Nous sommes là pour répondre à toutes vos questions',
  'contact.form.name': 'Nom Complet',
  'contact.form.email': 'Email',
  'contact.form.phone': 'Téléphone',
  'contact.form.message': 'Votre Message',
  'contact.form.submit': 'Envoyer le Message',
  'contact.form.success': 'Message envoyé avec succès !',
  'contact.info.title': 'Informations de Contact',
  'contact.info.phone': 'Téléphone',
  'contact.info.email': 'Email',
  'contact.info.whatsapp': 'WhatsApp',

  // Booking
  'booking.title': 'Réserver Votre Transfert',
  'booking.from': 'Départ',
  'booking.to': 'Destination',
  'booking.date': 'Date',
  'booking.time': 'Heure',
  'booking.passengers': 'Passagers',
  'booking.luggage': 'Bagages',
  'booking.name': 'Nom Complet',
  'booking.email': 'Email',
  'booking.phone': 'Téléphone',
  'booking.notes': 'Notes Supplémentaires',
  'booking.submit': 'Confirmer la Réservation',
  'booking.success': 'Réservation confirmée !',

  // Common
  'common.from': 'De',
  'common.to': 'À',
  'common.price': 'Prix',
  'common.duration': 'Durée',
  'common.distance': 'Distance',
  'common.loading': 'Chargement...',
  'common.error': 'Une erreur est survenue',
};

export default common;
